module.exports = new __parcel__URL__("your-work-itemlist-skeleton.tpl.e9027f83.svg").toString();